import { isProd } from "../config/isProd";

/**
 * @class Logger
 * @description Provides logging utilities.
 */
export class Logger {

  static isProduction = () => {
    if ( typeof isProd === 'function' ) return isProd();
    // Else fail to true so we fail silently.
    return true;
  }

  /**
   * Logs a message and optional data to the console.
   * @param {string} message - The message to log.
   * @param {Object} [data] - Optional data to log.
   */
  static log(message, data) {
    if ( !this.isProduction() ) {
      console.log(message, data || "");
    }
  }

  /**
   * Logs an error message and optional data to the console.
   * @param {string} message - The error message to log.
   * @param {Object} [data] - Optional data to log.
   */
  static error(message, data) {
    if ( !this.isProduction() ) {
      console.error(message, data || "");
    } 
  }

  /**
   * Logs a warning message and optional data to the console.
   * @param {string} message - The warning message to log.
   * @param {Object} [data] - Optional data to log.
   */
  static warn(message, data) {
    if ( !this.isProduction() ) {
      console.warn(message, data || "");
    }
  }

  /**
   * Logs an informational message and optional data to the console.
   * @param {string} message - The informational message to log.
   * @param {Object} [data] - Optional data to log.
   */
  static info(message, data) {
    if ( !this.isProduction() ) {
      console.info(message, data || "");
    }
  }
}